import React, { useMemo } from 'react';
import { Box, Stack, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { type MigrationStatus, Status } from '@atlassian/jira-project-create-importer-common';
import { Footer } from './footer';
import messages from './messages';

type Props = {
	migrationStatus: MigrationStatus;
	onDownloadClick: () => void;
};

export const PopoverContent = ({ migrationStatus, onDownloadClick }: Props) => {
	const { formatMessage } = useIntl();
	const { overallStatus: status, createdIssues, totalIssues, hasErrorLogs } = migrationStatus;

	const description = useMemo(() => {
		if (status === Status.SUCCESS) {
			return formatMessage(messages.importCompleteDescription, {
				count: createdIssues,
			});
		}
		if (status === Status.FAILED) {
			return hasErrorLogs
				? formatMessage(messages.importInCompleteDescription, {
						failed: totalIssues - createdIssues,
						total: totalIssues,
					})
				: formatMessage(messages.importInCompleteDescriptionWithoutErrorLogs);
		}
		return formatMessage(messages.importInProgressDescription);
	}, [createdIssues, formatMessage, hasErrorLogs, status, totalIssues]);

	return (
		<Stack xcss={contentStyles}>
			<Box xcss={descriptionStyles}>{description}</Box>
			<Footer migrationStatus={migrationStatus} onDownloadClick={onDownloadClick} />
		</Stack>
	);
};

const contentStyles = xcss({
	padding: 'space.200',
	width: '340px',
});

const descriptionStyles = xcss({
	font: token('font.body'),
	color: 'color.text.subtle',
	paddingBottom: 'space.200',
});
